// extracted by mini-css-extract-plugin
module.exports = {"tableCol":"Share_tableCol__18HS7","tableTitle":"Share_tableTitle__33odY","nameBox":"Share_nameBox__9e_7B","btns":"Share_btns__1AsdC"};